if (!customElements.get('sht-age-gate')) {
  class AgeGate extends HTMLElement {
    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || 'seaweed_age_verified';
      this.cookieDays = parseInt(this.dataset.cookieDays, 10) || 30;
      this.declineUrl = this.normalizeDeclineUrl(this.dataset.declineUrl || '/pages/compliance');
      this.dialog = this.querySelector('.age-gate__dialog');
      this.acceptBtn = this.querySelector('.js-age-gate-accept');
      this.declineBtn = this.querySelector('.js-age-gate-decline');
      this.lastFocus = null;
      this.inertedElements = [];
    }

    connectedCallback() {
      if (this.isVerified()) {
        this.remove();
        return;
      }
      this.show();
      this.acceptBtn && this.acceptBtn.addEventListener('click', this.onAccept.bind(this));
      this.declineBtn && this.declineBtn.addEventListener('click', this.onDecline.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    disconnectedCallback() {
      document.documentElement.classList.remove('age-gate-open');
      this.setBackgroundInert(false);
    }

    normalizeDeclineUrl(raw) {
      try {
        const url = new URL(raw, window.location.origin);
        if (url.origin !== window.location.origin) return '/pages/compliance';
        return url.pathname + url.search + url.hash;
      } catch (e) {
        return '/pages/compliance';
      }
    }

    isVerified() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return false;
        const stamp = parseInt(raw, 10);
        if (!stamp || stamp > Date.now()) return false;
        const ageMs = Date.now() - stamp;
        const maxMs = this.cookieDays * 24 * 60 * 60 * 1000;
        return ageMs >= 0 && ageMs < maxMs;
      } catch (e) {
        return false;
      }
    }

    show() {
      this.lastFocus = document.activeElement;
      document.documentElement.classList.add('age-gate-open');
      this.setBackgroundInert(true);
      this.removeAttribute('hidden');
      requestAnimationFrame(() => {
        this.acceptBtn && this.acceptBtn.focus();
      });
    }

    hide() {
      document.documentElement.classList.remove('age-gate-open');
      this.setBackgroundInert(false);
      this.setAttribute('hidden', '');
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
      this.remove();
    }

    setBackgroundInert(enable) {
      if (!enable) {
        this.inertedElements.forEach((el) => el.removeAttribute('inert'));
        this.inertedElements = [];
        return;
      }
      let anchor = this;
      while (anchor.parentElement && anchor.parentElement !== document.body) {
        anchor = anchor.parentElement;
      }
      const skip = ['SCRIPT', 'STYLE', 'LINK', 'TEMPLATE', 'NOSCRIPT'];
      Array.prototype.forEach.call(document.body.children, (el) => {
        if (el === anchor || skip.indexOf(el.tagName) !== -1) return;
        if (el.hasAttribute('inert')) return;
        el.setAttribute('inert', '');
        this.inertedElements.push(el);
      });
    }

    onAccept() {
      try {
        localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (e) {}
      this.hide();
    }

    onDecline() {
      window.location.replace(this.declineUrl);
    }

    onKeydown(e) {
      if (e.key !== 'Tab') return;
      const focusables = this.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('sht-age-gate', AgeGate);
}
